import { render, staticRenderFns } from "./Tentative.vue?vue&type=template&id=f4c81658&"
import script from "./Tentative.vue?vue&type=script&lang=js&"
export * from "./Tentative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports